import BaseModel from "@/core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export default class BulkAdjustPriceModel extends BaseModel {
  update_field = 'start_price';
  against = null;
  percentage = 0;
  price = 0;
  match_reserve = false;
  match_increments = true;

  rules = {
    against: 'required',
    percentage: 'required',
  };

  attributeLabels = {
    against: i18n.t('Calculate From'),
    percentage: i18n.t('Percentage'),
    price: i18n.t('Price'),
    match_reserve: i18n.t('Match Reserve'),
    match_increments: i18n.t('Match Increments')
  };

  attributeHints = {};

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
